export function OneIcon({ width = 41, height = 61 }) {
  return (
    <svg width={width} height={height} viewBox='0 0 43 59' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g filter='url(#filter0_i_1177_1188)'>
        <path
          d='M29.7445 -4.19044e-05V47.96H42.0645V58.96H1.93648V47.96H17.6885V13.2L3.69648 18.304L0.000476521 8.09596L20.3285 -4.19044e-05H29.7445Z'
          fill='#F5F7F9'
        />
      </g>
      <defs>
        <filter id='filter0_i_1177_1188' x='0' y='0' width='45.0645' height='58.96' filterUnits='userSpaceOnUse' colorInterpolationFilters='sRGB'>
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dx='3' />
          <feGaussianBlur stdDeviation='2.5' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0' />
          <feBlend mode='normal' in2='shape' result='effect1_innerShadow_1177_1188' />
        </filter>
      </defs>
    </svg>
  );
}
